import { render } from "./ebio.vue?vue&type=template&id=692790b2&scoped=true"
import script from "./ebio.vue?vue&type=script&lang=js"
export * from "./ebio.vue?vue&type=script&lang=js"

import "./ebio.vue?vue&type=style&index=0&id=692790b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-692790b2"]])

export default __exports__